import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OtpStyles.css";
import "./CustomerFormStyle.css";
import WatchVideo from "./WatchVideo";
import { onecodeAPI } from "../AppConfig";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Context } from "../App";
import { isNumber } from "../utils/regexConstants";
import _ from "lodash";

const OTP = ({
  setCurrentScreen,
  customerName,
  customerPhoneNum,
  currentScreen,
  isCreditScoreCheck,
  cusStatusforCreditScore,
  cusHashforCreditScore,
  customerId,
  setCustomerId,
}) => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [invalidOTP, setInvalidOTP] = useState(false);
  const [counter, setCounter] = React.useState(120);
  const [timeLeft, setTimeLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [reloading, setReloading] = useState(false);
  const {t} =  useTranslation();
  const[clickResend,setClickResend]=useState(0);
  const[lockedTill,setLockedTill]=useState({});
  const { isMyTeamsFlow } = useContext(Context);


  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
  );

  //Resend OTP
  const addCustomer = async () => {
    window?.Moengage?.track_event("add-customer_customer_resend_otp");
    setClickResend(clickResend+1);

    if(isCreditScoreCheck){
      window?.Moengage?.track_event("credit-score_resend_otp");
    }
    try {
      setReloading(true);
      setOtp(new Array(4).fill(""));
      setInvalidOTP(false);
      // console.log("hash otp before", searchParams.get("hash"));
      let hash = encodeURIComponent(searchParams.get("hash"));
      // console.log("hash otp", hash);
      const res = await onecodeAPI.post(`public/customer/addCustomerOtp?isCreditCheck=${isCreditScoreCheck}`, {
        fullName: customerName,
        phoneNumber: customerPhoneNum,
        hash: hash,
        
      });
      let locked= _.get(res , "data.lockedTill");
      let reaso=_.get(res,"data.reason");
      setCustomerId(res.data.customerId)
      const object={      
        "locktill":locked,
       "reason":reaso,
      }

      setLockedTill(object)

      setCounter(120);
      setReloading(false);
    } catch (error) {
      setReloading(false);
      console.log("error-otp", error);
    }
  };

  // Verifying OTP
  function handleClick() {
    window?.Moengage?.track_event("add-customer_customer_verify_otp");
    if(isCreditScoreCheck){
      window?.Moengage?.track_event("credit-score_verify_otp")
    }
    if (otp.join("").trim().length < 4) {
      setInvalidOTP(true);
    } else {
      setLoading(true);
      // console.log("searchParams.get=====", searchParams.get("hash"));
      let hash = encodeURIComponent(searchParams.get("hash"));
      // console.log("hash==", hash);
      onecodeAPI
        .post(`/public/customer/verifyOtp?isCreditCheck=${isCreditScoreCheck}`, {
          name: customerName,
          otp: otp.join("").trim(),
          phoneNumber: customerPhoneNum,
          hash: hash,
          customerId: customerId || 0
        })
        .then((res) => {
          let msg = res.data;
          // console.log("msg otp", res);
          sessionStorage.setItem("initialCusStatus",cusStatusforCreditScore < 3 ? 3 : cusStatusforCreditScore);
          if (msg === "otp Verified" && (cusStatusforCreditScore == 7 || cusStatusforCreditScore == 5 )) {
            navigate(`/customer/recommendations`, {
              state: {
                hash: cusHashforCreditScore,
                isCreditScoreCheck: isCreditScoreCheck,
              },
            });
          } else if (msg === "otp Verified") {
            setCurrentScreen(2);
          } else {
            setInvalidOTP(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err, "err");
          alert("Something went wrong");
        });
    }
  }

  // Timer Details
  function TimeFormat(duration) {
    //  minutes and seconds
    var mins = Math.floor((duration % 3600) / 60);
    let secs = Math.floor(duration % 60);

    let remainTime = "";
    if (mins > 0) remainTime += "" + mins + " min " + (secs < 10 ? "0" : "");
    remainTime += "" + secs + (secs === 1 ? " second" : " seconds");

    return remainTime;
  }

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    setTimeLeft(TimeFormat(counter));
    return () => clearInterval(timer);
  }, [counter]);

  const handleChange = (element, index) => {
    // enableButton(element.target.value);
    if (isNaN(element.value)) return false;
    if (element.value.length > 1) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    setInvalidOTP(false);
  };

  const handleKeyUp = (element) => {    
    if (element.value.length == 0 && element.previousSibling) {
      element.previousSibling.focus()
    }
    else if (element.value.length > 0 && element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const navigate = useNavigate();

  return (
    <div>
      <div className="row">
        <div
          className="name"
          style={{
            marginTop: isCreditScoreCheck ? "70px" : "",
          }}
        >
          <b>
            {t("addcustomerstep2.hello")} {customerName}!
          </b>
          <p>
            {t("addcustomerstep2.EnterTheOtp")}
            {customerPhoneNum}
            {t("addcustomerstep2.viaSms")}{" "}
          </p>
          {counter > 0 ? (
            <p className="expire">Expires in {timeLeft}</p>
          ) : (
            <div>
              <button onClick={addCustomer} type="submit" className="resend">
                {reloading && <Spin indicator={antIcon} />}
                Resend OTP
              </button>
            </div>
          )}

        </div>
        <div className="otp-box">
          {otp.map((data, index) => {
            return (
              <input
                className="otp-field"
                // type="number"
                type="text"
                pattern="[0-9]+"
                name="otp"
                maxLength="1"
                key={index}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onKeyUp={(e) => handleKeyUp(e.target)}
                onFocus={(e) => e.target.select()}
              />
            );
          })}
        </div>
        {invalidOTP && (
          <div
            style={{
              width: "50%",
              margin: "1px auto",
              color: "red",
              fontSize: "0.6rem",
              alignSelf: "center",
              textAlign: "center",
            }}
          >
            Invalid OTP
          </div>
        )}

{clickResend>3?(
          <div>
            <p style={{alignSelf: "center",textAlign: "center",color:"red"}}>{lockedTill.reason}</p> 
            <p style={{alignSelf: "center",textAlign: "center",color:"red",marginTop:-10}}>{lockedTill.locktill}</p>                     
            </div>
        ):null}

        <div className="verify-btn">
          <button
            type="submit"
            className="verify"
            onClick={handleClick}
            // onClick={isCreditScoreCheck?()=>navigate("/creditScore"):handleClick}
          >
            {loading && <Spin indicator={antIcon} />}
            Submit OTP 
          </button>
        </div>

        {isCreditScoreCheck ? (
          <></>
        ) : (
          <WatchVideo
            videoTitle={t("addcustomerstep2.otpConsent")}
            videoId={t("addcustomerstep2.videoId")}
            currentScreen={currentScreen}
            thumbnail={
              "https://onecode-asset.s3.ap-south-1.amazonaws.com/Revamp+UI+Thumbnails/OTP_Customer_Thumbnail.jpg"
            }
          />
        )}
      </div>
    </div>
  );
};

export default OTP;
